module.exports = __webpack_public_path__ + "static/media/Mask-group-optimized.64847081.webp";